import { render, staticRenderFns } from "./OrderVerify.vue?vue&type=template&id=58221580&scoped=true"
import script from "./OrderVerify.vue?vue&type=script&lang=js"
export * from "./OrderVerify.vue?vue&type=script&lang=js"
import style0 from "./OrderVerify.vue?vue&type=style&index=0&id=58221580&prod&lang=scss&scoped=true"
import style1 from "./OrderVerify.vue?vue&type=style&index=1&id=58221580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58221580",
  null
  
)

export default component.exports